export const preloadImage = (url: string): Promise<any> => {
  const img = new Image()
  img.src = url

  return new Promise((resolve, reject) => {
    img.onload = resolve
    img.onerror = reject
  })
}

export const preloadImagesList = (imgs: string[]): Promise<any> => {
  const urls = imgs.map((item) => {
    const matched = item.replace(/.*src="([^"]*)".*/, '$1')

    return matched && matched.length && preloadImage(matched)
  })

  return Promise.allSettled(urls)
}

export const matchImgTag = (text: string): string[] | null => text.match(/<img (.*?)>/g)
